import {
  ContentBlock,
  Card,
  Stack,
  TabPanels,
  TabsProvider,
  TabPanel,
  Box,
} from 'braid-design-system';
import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import Header from 'src/components/Header/Header';
import type { StoreProps } from 'src/store';

import ListingsTab from './components/ListingsTab/ListingsTab';
import Navigation from './components/Navigation/Navigation';
import ProductsTab from './components/ProductsTab/ProductsTab';
import ToolsTab from './components/ToolsTab/ToolsTab';

const Dashboard = () => {
  const paid = useSelector(({ account }: StoreProps) => account.paid);
  const [searchParams] = useSearchParams();
  const defaultSelectedTab =
    searchParams.get('selectedTab') ?? (paid ? 'listings' : 'products');
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  return (
    <Fragment>
      <Header title="Sell your business" />
      <ContentBlock width="large">
        <Box paddingTop="large">
          <TabsProvider
            id="dashboardTabs"
            selectedItem={selectedTab}
            onChange={(index, item) => setSelectedTab(String(item))}
          >
            <Stack space="medium">
              <Navigation paid={paid} />
              <Card>
                <TabPanels>
                  <TabPanel item="listings">
                    <ListingsTab />
                  </TabPanel>
                  <TabPanel item="tools">
                    <ToolsTab />
                  </TabPanel>
                  <TabPanel item="products">
                    <ProductsTab />
                  </TabPanel>
                </TabPanels>
              </Card>
            </Stack>
          </TabsProvider>
        </Box>
      </ContentBlock>
    </Fragment>
  );
};
export default Dashboard;
